import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const EditYachtPage = withSuspense(
	lazy(async () => await import('./edit-yacht-page.component')),
	PageLoader,
);
